import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4c4999a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "paymentModalLabel"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "关闭"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

import { PayInfo } from "../../types/types"
import { ref, onMounted, onUnmounted } from 'vue';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Modal } from 'bootstrap';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayModal',
  setup(__props, { expose: __expose }) {



const isLoading = ref(false);
const payInfo = ref<PayInfo | null>(null);
const payRef = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;
let elements: StripeElements;
let stripeInstance: Stripe;

onMounted(() => {
    modalInstance = new Modal(payRef.value!, { keyboard: false });
});

onUnmounted(() => {
    modalInstance?.dispose();
});

async function initStripe() {
    if (!payInfo.value) return;
    try {
        loadStripe.setLoadParameters({ advancedFraudSignals: false });
        const stripe = await loadStripe(payInfo.value.publishableKey);
        if (!stripe) throw new Error('Stripe 加载失败');
        stripeInstance = stripe;
        elements = stripe.elements({ clientSecret: payInfo.value.clientSecret, appearance: { theme: 'stripe' } });
        const paymentElement = elements.create('payment', { layout: "tabs" });
        paymentElement.mount("#payment-element");
    } catch (error) {
        console.error(error);
    }
}

const showModal = async (info: PayInfo) => {
    payInfo.value = info;
    await initStripe();
    modalInstance?.show();
};



async function handleSubmit() {

    if (isLoading.value) {
        return
    }
    isLoading.value = true;
    const currentPageUrl: string = window.location.href;
    try {

        const result = await stripeInstance.confirmPayment({
            elements,
            confirmParams: {
                return_url: currentPageUrl,
            },
        });
        modalInstance?.hide();
        // cancelLoop()
        // 处理支付确认结果
        console.log("result: ", result)
        if (result.error) {
            isLoading.value = false;
        }
    } catch (error) {
        console.error(error);
        // 处理错误
    } finally {
        isLoading.value = false;
    }
}

const hideModal = () => modalInstance?.hide();

__expose({ showModal, hideModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "paymentModal",
    tabindex: "-1",
    "aria-labelledby": "paymentModalLabel",
    "aria-hidden": "true",
    ref_key: "payRef",
    ref: payRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("message.place_order")), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-lg btn-block payment-button", ['btn', isLoading.value ? 'btn-secondary' : 'btn-primary']]),
            disabled: isLoading.value,
            onClick: handleSubmit
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(isLoading.value ? _ctx.$t("message.processing") : _ctx.$t("message.place_order") + " US$" + (payInfo.value?.amount)), 1)
          ], 10, _hoisted_8)
        ])
      ])
    ])
  ], 512))
}
}

})